import React from 'react';
import { Link } from 'react-router-dom';
import {
  APP_STORE_URL,
  CREDIT_LINE,
  EMERGENCY_NUMBER,
  PLAY_URL,
  SHOW_CREDIT_LINE,
  SUPPORT_PHONE,
  SUPPORT_TEL,
} from '../config/site';
import Icon from './Icon';
import { QuickExitLink } from './QuickExit';

const Footer: React.FC = () => (
  <footer className="site-footer" data-inert-when-menu>
    <div className="container">
      <div className="footer__top">
        <p className="footer__claim">
          Tu red de apoyo, <span>en tu teléfono.</span>
        </p>
        <div className="footer__stores">
          <a className="store store--light" href={PLAY_URL} rel="noopener">
            <Icon name="google-play" />
            <span>
              <small>Descargar en</small>
              <b>Google Play</b>
            </span>
          </a>
          <a className="store store--light" href={APP_STORE_URL} rel="noopener">
            <Icon name="apple" />
            <span>
              <small>Descargar en el</small>
              <b>App Store</b>
            </span>
          </a>
        </div>
      </div>

      <div className="footer__grid">
        <div className="footer__brand">
          <Link className="brand" to="/" aria-label="Violeta, ir al inicio">
            <img src="/assets/logo-96.png" width="44" height="44" alt="" />
            <span className="brand__name">Violeta</span>
          </Link>
          <p>Una app de apoyo para mujeres en Venezuela.</p>
          {SHOW_CREDIT_LINE && (
            <p className="footer__credit">{CREDIT_LINE}</p>
          )}
        </div>

        <nav className="footer__col" aria-labelledby="f-app">
          <h2 id="f-app">La app</h2>
          <ul>
            <li><Link to="/#como-funciona">Cómo funciona</Link></li>
            <li><Link to="/#preguntas">Preguntas frecuentes</Link></li>
            <li><Link to="/descargar">Descargar</Link></li>
            <li><Link to="/actualizar">Actualizar la app</Link></li>
          </ul>
        </nav>

        <nav className="footer__col" aria-labelledby="f-help">
          <h2 id="f-help">Ayuda</h2>
          <ul>
            <li><Link to="/ayuda">Líneas de ayuda</Link></li>
            <li><Link to="/comentarios">Escríbenos</Link></li>
            <li>
              <a className="footer__tel" href={SUPPORT_TEL}>
                <Icon name="phone" />
                <span>
                  {SUPPORT_PHONE}
                  <small>Teléfono de la app, no de emergencias</small>
                </span>
              </a>
            </li>
            <li><Link to="/politica-de-privacidad">Política de privacidad</Link></li>
            <li><Link to="/eliminar-cuenta">Eliminar mi cuenta</Link></li>
          </ul>
        </nav>

        <div className="footer__col footer__discreet">
          <h2>Navega con discreción</h2>
          <p>
            Si alguien más usa este dispositivo, puedes borrar esta visita del historial de tu navegador. En Chrome,
            toca <b>⋮</b>, luego <b>Historial</b>, y la <b>X</b> junto a Violeta.
          </p>
          <QuickExitLink className="link-btn" />
        </div>
      </div>

      <div className="footer__bottom">
        <p>
          <strong>Violeta no es un servicio de emergencias.</strong> Si estás en peligro, llama al{' '}
          <a className="tap" href={`tel:${EMERGENCY_NUMBER}`}>{EMERGENCY_NUMBER}</a>.
        </p>
        <p>&copy; {new Date().getFullYear()} Violeta</p>
      </div>
    </div>
  </footer>
);

export default Footer;
